module.exports = __webpack_public_path__ + "img/my.e6739f40.svg";